import React from "react";
import {Button, Form, Input, notification} from 'antd';
import {savePassword} from "../../util/APIUtils";
import {useHistory} from "react-router-dom";
import {showAxiosError} from "../../util/Helpers";
import {PASSWORD_ERROR_MESSAGE, PASSWORD_REGEX} from "../../constants";

function ChangePassword(props) {
    let history = useHistory();

    function onFinish(values) {
        values.token = props.token;
        savePassword(JSON.stringify(values)).then((response) => {
            if (response.data === "OK") {
                notification.success({
                    message: "Başarılı",
                    description: "Kayıt işleminiz başarılı bir şekilde gerçekleşti. Lütfen giriş yapınız!",
                });
                history.push("/login");
            }
        }).catch(error => {
            showAxiosError(error.response);
        })
    }

    return (
        <div style={{
            marginTop: "250px",
            marginLeft: "auto",
            marginRight: "auto",
            width: "50%",
            padding: "10px"
        }}>

            <Form layout="vertical" className="sign-up-form" onFinish={onFinish}>
                <Form.Item
                    label="Şifre"
                    name="password"
                    rules={[
                        {
                            required: true,
                            min: 8,
                            message: "Lütfen Şifrenizi Giriniz.",
                        },
                        () => ({
                            validator(_, value) {
                                if (PASSWORD_REGEX.test(value)) {
                                    return Promise.resolve();
                                }

                                return Promise.reject(
                                    new Error(
                                        PASSWORD_ERROR_MESSAGE
                                    )
                                );
                            },
                        }),
                    ]}
                >
                    <Input.Password
                        className="sign-up-form-input"
                        name="password"
                        size="large"
                    />
                </Form.Item>

                <Form.Item
                    name="confirmPassword"
                    label="Şifre Onayla"
                    dependencies={["password"]}
                    hasFeedback
                    rules={[
                        {
                            required: true,
                            message: "Lütfen Şifrenizi Doğrulayın",
                        },
                        ({getFieldValue}) => ({
                            validator(_, value) {
                                if (!value || getFieldValue("password") === value) {
                                    return Promise.resolve();
                                }

                                return Promise.reject(new Error("Şifreniz Eşleşmiyor."));
                            },
                        }),
                    ]}
                >
                    <Input.Password
                        className="sign-up-form-input"
                        name="confirmPassword"
                        size="large"
                    />
                </Form.Item>


                <Form.Item>
                    <Button
                        type="primary"
                        htmlType="submit"
                        className="sign-up-submit-btn d-flex align-center justify-center"
                        name="submit"
                    >
                        <p>Kaydet</p>
                    </Button>
                </Form.Item>
            </Form>
        </div>

    )
}

export default ChangePassword;


// WEBPACK FOOTER //
// ./src/page/forgotPassword/ChangePassword.js